import { createContext } from 'react';
import {
  Aggregate,
  AggregateCategories,
  AddonOption,
} from '../../Types/Aggregates';
import { Project } from '../../Types/Project';

export interface DataContextApi {
  showSideMenu: boolean;
  toggleSideMenu: () => void;
  resetStorageData: () => void;
  setActiveUserInputs: (inputs: any) => void;
  projects: Array<any>;
  activeUserInputs: any;
  activeAggregate: Aggregate | null;
  setActiveAggregate: (aggregate: Aggregate | null) => void;
  setProjects: (projects: Project[]) => void;
  aggregates: Aggregate[];
  setAggregates: (aggregates: Aggregate[]) => void;
  latestCalcResults: AggregateCategories[];
  setLatestCalcResults: (aggregateCategories: AggregateCategories[]) => void;
  // New: result lifecycle tracking
  selectedResultId: string | null;
  setSelectedResultId: (id: string | null) => void;
  alternativeTo: string | null;
  setAlternativeTo: (id: string | null) => void;
  hasUnsavedChanges: boolean;
  markAsSaved: () => void;
  startNewCalculation: () => void;
  // Clear user-specific data (called on user change)
  clearUserData: () => void;
  onUserChange: (userId: string | number | undefined) => void;
  // Load saved result data without triggering unsaved changes
  loadSavedResultData: (inputs: any, aggregate: Aggregate | null) => void;
  // Available addons for current aggregate/power supply
  availableAddons: AddonOption[];
  setAvailableAddons: (addons: AddonOption[]) => void;
  fetchAvailableAddons: (
    aggregateId: number | string,
    powerSupply: string
  ) => Promise<AddonOption[]>;
}

const DataContext = createContext({} as DataContextApi);

export default DataContext;
